import logo from './logo.svg';
import './App.css';
import VehicleTracking from "./VehicleTracking";

function App() {
  return (
    <div className="App">
      <div>
            <h1>Vehicle Tracking System</h1>
            <VehicleTracking />
        </div>
    </div>
  );
}

export default App;
